"use client"

// src/styles/layer-styles.ts
var layerStyles = {};

export {
  layerStyles
};
//# sourceMappingURL=chunk-XWKIDEDQ.mjs.map